<template>
  <div class="b-legal mb-2">
    <slot />
  </div>
</template>
<script>
export default {
  name: "BLegal"
}
</script>
,

<style lang="scss" scoped>
.b-legal {
  @include font-style(legal);
}
</style>
